import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import TipTapEditor from "components/helpers/TipTapEditor/TipTapEditor";
import Uploader from "components/helpers/uploader/Uploader";
import { debug } from 'utils';
import './customer-message-modal.css'
export default function CustomerMessageModal({
  show = true,
  onClose,
  onSend,
  sender,
  defaultMessages = [],
  messageId = null,
  subject: subjectProp,
  body: bodyProp,
  attachments: attachmentsProp = [], // fichiers existants (backend)
  children,
  extraPayload = {},
}) {
  /* ----------------------------
     States
  ---------------------------- */
  const [cc, setCc] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [selectedMessageId, setSelectedMessageId] = useState("");
  // fichiers existants (backend)
  const [attachments, setAttachments] = useState([]);
  /* ----------------------------
     Initialisation
  ---------------------------- */
  useEffect(() => {
    if (Array.isArray(attachmentsProp)) {
      setAttachments(attachmentsProp);
    } else {
      setAttachments([]);
    }
  }, [attachmentsProp]);
  useEffect(() => {
    if (!show) return;

    if (messageId && defaultMessages.length) {
      const msg = defaultMessages.find(
        (m) => String(m.id) === String(messageId)
      );
      if (msg) {
        setSelectedMessageId(msg.id);
        setSubject(msg.subject || "");
        setBody(msg.body || "");
        return;
      }
    }

    if (subjectProp !== undefined) setSubject(subjectProp);
    if (bodyProp !== undefined) setBody(bodyProp);

  }, [show, messageId]);
  /* ----------------------------
     Handlers
  ---------------------------- */
  const handleSelectMessage = (e) => {
    const id = e.target.value;
    setSelectedMessageId(id);
    const msg = defaultMessages.find(
      (m) => String(m.id) === String(id)
    );
    if (!msg) return;
    setSubject(msg.subject || "");
    setBody(msg.body || "");
  };
  const handleUploadSuccess = (file) => {
    if (!file || file.status !== "uploaded") return;
    setAttachments((prev) => [
      ...prev,
      {
        ...file,
        _isNew: true, // flag utile côté backend plus tard
      }
    ]);
  };
  const handleRemoveAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };
  const handleSend = () => {
    if (!onSend) return;
    onSend({
      cc,
      subject,
      body,
      attachments,
      ...extraPayload,
    });
  };
  /* ----------------------------
     Render
  ---------------------------- */
  return (
    <Modal show={show} onHide={onClose} size="lg" backdrop="static" className="customer-message-modal ">
      <Modal.Header closeButton>
        <Modal.Title>Envoyer un email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Expéditeur */}
        {sender && (
          <Form.Group className="mb-3 d-flex align-items-center gap-2">
            <Form.Label className="mb-0 text-nowrap" >De :</Form.Label>
            <div className="form-control-plaintext">
              {sender.name} ({sender.email})
            </div>
          </Form.Group>
        )}
        {/* Messages préconfigurés */}
        {defaultMessages.length > 0 && (
          <Form.Group className="mb-3">
            <Form.Label>Message préconfiguré</Form.Label>
            <Form.Select
              value={selectedMessageId}
              onChange={handleSelectMessage}
            >
              <option value="">— Aucun —</option>
              {defaultMessages.map((msg) => (
                <option key={msg.id} value={msg.id}>
                  {msg.subject}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
        {/* CC */}
        <Form.Group className="mb-3 d-none">
          <Form.Label>Copie :</Form.Label>
          <Form.Control
            type="text"
            placeholder="email1@domaine.fr, email2@domaine.fr"
            value={cc}
            onChange={(e) => setCc(e.target.value)}
          />
        </Form.Group>
        {/* Objet */}
        <Form.Group className="mb-3">
          <Form.Label>Objet :</Form.Label>
          <Form.Control
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </Form.Group>
        {/* Message */}
        <Form.Group className="mb-3">
          <Form.Label>Message :</Form.Label>
          <TipTapEditor value={body} onChange={setBody} />
        </Form.Group>
        {/* Pièces jointes */}
        <div className="mb-3">
          <label className="form-label fw-semibold d-block">
            Pièces jointes
          </label>
          <Uploader onUploadSuccess={handleUploadSuccess} uploadId="mails" />
          {attachments.length > 0 && (
            <ul className="mt-2 small mb-0 ms-0 ps-0 list-unstyled">
              {attachments.map((file, i) => (
                <li
                  key={`attachment-${i}`}
                  className="d-flex align-items-center justify-content-between border-bottom py-1"
                  style={{ width: "260px" }}
                >
                  <div
                    className="text-truncate me-2"
                    style={{ width: "240px" }}
                  >
                    {file.frdLabel || file.name}
                    {file._isNew && (
                      <span className="text-muted ms-1">(nouveau)</span>
                    )}
                  </div>
                  <FiX
                    size={16}
                    className="text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleRemoveAttachment(i)}
                    title="Supprimer"
                  />
                </li>
              ))}
            </ul>
          )}
          {false && debug(attachments)}
        </div>
        {/* Extensions métier */}
        {children && <div className="mt-4">{children}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="rounded-pill" onClick={onClose}>
          Annuler
        </Button>
        <Button variant="primary" className="rounded-pill" onClick={handleSend}>
          Envoyer
        </Button>
      </Modal.Footer>
    </Modal>
  );
}